import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyImport, LazyModule, createLazyComponent } from "owa-bundling";
import { getStore } from "./store/store";

export const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "TriageActionImportExport"*/ "./lazyIndex"), { name: "TriageActionImportExport" });

export const lazyDownloadEmailAsBlob: LazyAction<typeof lazyIndex.downloadEmailAsBlob, typeof lazyModule> = new LazyAction(lazyModule, m => m.downloadEmailAsBlob);

export const lazyFetchEmailContentAndDownload: LazyAction<typeof lazyIndex.fetchEmailContentAndDownload, typeof lazyModule> = new LazyAction(lazyModule, m => m.fetchEmailContentAndDownload);

export const lazyExportItemAsDataStream: LazyAction<typeof lazyIndex.exportItemAsDataStream, typeof lazyModule> = new LazyAction(lazyModule, m => m.exportItemAsDataStream);

export const lazyImportItemFromDataStream: LazyAction<typeof lazyIndex.importItemFromDataStream, typeof lazyModule> = new LazyAction(lazyModule, m => m.importItemFromDataStream);

export const lazyCopyItems: LazyImport<typeof lazyIndex.copyItems, typeof lazyModule> = new LazyImport(lazyModule, m => m.copyItems);

export const lazyCopyItemToNewMailboxIfAllowed: LazyImport<typeof lazyIndex.copyItemToNewMailboxIfAllowed, typeof lazyModule> = new LazyImport(lazyModule, m => m.copyItemToNewMailboxIfAllowed);

export const lazyIsMoveCopyAllowedByPolicy: LazyImport<typeof lazyIndex.isMoveCopyAllowedByPolicy, typeof lazyModule> = new LazyImport(lazyModule, m => m.isMoveCopyAllowedByPolicy);

export const lazySyncItemExportPst: LazyAction<typeof lazyIndex.syncItemExportPst, typeof lazyModule> = new LazyAction(lazyModule, m => m.syncItemExportPst);

export const LazyMoveCopyAttachCrossAccountDialog: typeof lazyIndex.MoveCopyAttachCrossAccountDialog = createLazyComponent(lazyModule, m => m.MoveCopyAttachCrossAccountDialog, undefined, undefined, {
    onlyImportIf: () => getStore().isShown,
});
